import { Bin } from '@src/warehouse/interfaces/bin.js';
import apiClient from '@src/api/api-client.js';
import { closeLoader, openLoader } from '@utils/loader-util.js';

export async function fetchBinById(id: number) {
    openLoader();
    const bin: Bin = (await apiClient.get('/be/warehouse/bin/' + id)).data;
    closeLoader();

    return bin;
}

export async function getTotalStockByBin(bin: Bin) {
    openLoader();
    const totalStock = (await apiClient.get('/be/stock/total-stock-on-bin/' + bin.idBin)).data;
    closeLoader();

    return totalStock;
}
